import {
  Banknote,
  ChartAreaIcon,
  Clock,
  Cog,
  CreditCard,
  DollarSign,
  File,
  Files,
  Gift,
  Home,
  LineChart,
  Link2Icon,
  MessageCircleQuestion,
  NotebookIcon,
  PlusCircle,
  ShoppingBag,
  Signal,
  ToolCaseIcon,
  User2Icon,
  Users2,
} from "lucide-react";
import { twMerge } from "tailwind-merge";

type UserTypes = "ordinary" | "panel" | "webservice" | "admin" | "esaj";

interface SidebarLink {
  title: string;
  href: string;
  icon: ({ className }: { className?: string }) => React.ReactElement;
  children?: Array<SidebarLink>;
  access?: Array<UserTypes>;
  /** فقط بعد از تایید پروفایل نمایش داده شود */
  confirmedOnly?: boolean;
  count?: number;
}

export const usersMenu: Array<SidebarLink> = [
  {
    title: "خانه",
    href: "/",
    icon: ({ className }) => <Home className={twMerge(className)} />,
  },
  {
    title: "مرکز پیام",
    href: "/support/tickets",
    icon: ({ className }) => (
      <MessageCircleQuestion className={twMerge(className)} />
    ),
  },
  {
    title: "افزایش اعتبار",
    href: "/payment/bank",
    icon: ({ className }) => <PlusCircle className={twMerge(className)} />,
    access: ["panel", "webservice"],
  },
  {
    title: "خرید شارژ گروهی",
    href: "/group-charge",
    icon: ({ className }) => <Users2 className={twMerge(className)} />,
    access: ["panel"],
  },
  {
    title: "خرید کارت شارژ",
    href: "/card-charge",
    icon: ({ className }) => <CreditCard className={twMerge(className)} />,
    access: ["panel", "webservice"],
  },
  {
    title: "محصولات",
    href: "/client/products",
    icon: ({ className }) => <Files className={twMerge(className)} />,
    access: ["webservice"],
  },
  {
    title: "فروشگاه",
    href: "/shop",
    icon: ({ className }) => <ShoppingBag className={twMerge(className)} />,
    access: ["panel"],
  },
  {
    title: "گزارشات",
    href: "",
    icon: ({ className }) => <ChartAreaIcon className={twMerge(className)} />,
    access: ["panel", "webservice"],
    children: [
      {
        title: "گزارش افزایش اعتبار",
        href: "/client/payment",
        icon: ({ className }: { className?: string }) => (
          <Banknote className={twMerge(className)} />
        ),
      },
      {
        title: "جزئیات فروش",
        href: "/client/sale/report",
        icon: ({ className }: { className?: string }) => (
          <LineChart className={twMerge(className)} />
        ),
      },
      {
        title: "تراکنش ها",
        href: "/client/transactions",
        icon: ({ className }: { className?: string }) => (
          <CreditCard className={twMerge(className)} />
        ),
      },
      {
        title: "استعلام شماره",
        href: "/client/inquiry",
        icon: ({ className }) => <User2Icon className={twMerge(className)} />,
      },
      {
        title: "مانده حساب",
        href: "/client/daily",
        icon: ({ className }) => <Signal className={twMerge(className)} />,
      },
      {
        title: "مبالغ دریافتی",
        href: "/wallet/extra",
        icon: ({ className }) => <DollarSign className={twMerge(className)} />,
        access: ["panel"],
      },
      {
        title: "نمودار ها",
        href: "/client/sale/report/charts",
        icon: ({ className }: { className?: string }) => (
          <LineChart className={twMerge(className)} />
        ),
        access: ["panel"],
      },
    ],
  },
  {
    title: "دفترچه تلفن",
    href: "/phone-book",
    icon: ({ className }) => <NotebookIcon className={twMerge(className)} />,
    access: ["panel"],
  },
  {
    title: "جوایز",
    href: "/client/prizes",
    icon: ({ className }: { className?: string }) => (
      <Gift className={twMerge(className)} />
    ),
    access: ["panel"],
  },
  {
    title: "صف خرید زمان دار",
    href: "/queues",
    icon: ({ className }) => <Clock className={twMerge(className)} />,
    access: ["panel"],
  },
  {
    title: "تنظیمات",
    href: "/client/settings",
    icon: ({ className }) => <Cog className={twMerge(className)} />,
  },
  {
    title: "وضعیت اپراتور ها",
    href: "/operator/status",
    icon: ({ className }) => <Signal className={twMerge(className)} />,
  },
  {
    title: "تراکنش ها",
    href: "/client/transactions",
    icon: ({ className }: { className?: string }) => (
      <CreditCard className={twMerge(className)} />
    ),
    access: ["ordinary"],
    confirmedOnly: true,
  },
  {
    title: "دسترسی ها",
    href: "/client/tokens",
    icon: ({ className }) => <Cog className={twMerge(className)} />,
    access: ["webservice"],
  },
  {
    title: "ابزار های کاربردی",
    href: "/useful-links",
    icon: ({ className }) => <ToolCaseIcon className={twMerge(className)} />,
  },
  {
    title: "مستندات",
    href: "https://docs.esaj.ir/",
    icon: ({ className }: { className?: string }) => (
      <File className={twMerge(className)} />
    ),
    access: ["webservice"],
  },
];
